import sdk from 'redcatSdk'
import { forms, processes } from './funitions.js'
import { UUID } from '@/plugins/common'
import { registerSdkComponents } from '@/store/form/componentDefaults.js'

export function initSdk (root) {
  sdk.init(root, {
    UUID
  })
  registerSdkComponents()
}

export function loadExtensionScript () {
  sdk.exts.bindFunctions(forms, 'form')
  sdk.exts.bindFunctions(processes, 'process')
}

class CodeService {
  code = ''
  context

  constructor (context) {
    this.context = {
      eventBus: context.eventBus
    }

    if (context.form) {
      this.context.form = context.form
      if (context.formService) {
        this.context.formService = context.formService
      }
    } else if (context.report) {
      this.context.report = context.report
      if (context.reportService) {
        this.context.reportService = context.reportService
      }
    } else if (context.process) {
      this.context.process = context.process
    }

    if (context.el) {
      this.context.el = context.el
    }
  }

  load () {
    let key

    if (this.context.form) {
      key = this.context.form.define.id
    } else if (this.context.report) {
      key = this.context.report.id
    } else if (this.context.process) {
      key = this.context.process.define.componentId
    }

    if (key) {
      const fn = sdk.exts.functionManager.functionMap[key]
      fn && fn(this.context)
    }
  }
}

class EventBus {
  listeners = {}

  $on (event, callback) {
    if (!(callback instanceof Function)) {
      throw new Error('callback is not a function.')
    }

    if (!(event in this.listeners)) {
      this.listeners[event] = []
    }

    // 根据函数内容排重
    let index = this.listeners[event].map(n => n.toString()).indexOf(callback.toString())
    if (index === -1) {
      this.listeners[event].push(callback)
    } else {
      this.listeners[event][index] = callback
    }
  }

  $emit (event, args) {
    if (!(event in this.listeners)) {
      return
    }
    const promises = []
    for (const stack of this.listeners[event]) {
      promises.push(stack.call(this, args))
    }
    return Promise.all(promises)
  }
}

export default CodeService
export {EventBus}



// WEBPACK FOOTER //
// ./src/plugins/redcatSdk/index.js